import React from 'react';
import CircularProgress from 'material-ui/CircularProgress';
import ProjectCard from './ProjectCard';
import queries from '../../graphql/queries';
import CreateProjectCard from './CreateProjectCard';
import { compose } from 'react-apollo';
import { GraphQLStackTrace } from '../../utils/utils'
import './ProjectList.css';

class ProjectList extends React.Component {
    render() {
        if (this.props.data.loading) {
            return (
                <CircularProgress className="activityIndicator"/>
            )
        } else if (this.props.data.error) {
            return <pre>{GraphQLStackTrace(this.props.data.error)}</pre>;
        } else {
            return (
                <div id="projectListContainer">
                    <h2>Projects</h2>
                    <ul className="project-list">
                        {this.props.data.projects.map(project =>
                            <li key={project.id}>
                                <ProjectCard project={project} />
                            </li>
                        )}
                        <li key="createProjectCard">
                            <CreateProjectCard />
                        </li>
                    </ul>
                </div>
            );
        }
    }
}

export default compose(
    queries.projectsQueryHoc
)(ProjectList);



// WEBPACK FOOTER //
// ./src/components/projectList/ProjectList.js